// import { useState } from "react";

export default function HeaderComponent() {
  let logo_image = process.env.REACT_APP_IMAGES + 'avalon-logo.png';
  return (
    <div className="outer-header">
      <a href="./"><img src={logo_image} alt="logo" className="header-logo" /></a>
    </div>
  );
}